import { Controller } from "@hotwired/stimulus";

export default class ComponentControllerBase extends Controller {
    static values = {
        getJobUrl: String,
        analyticsContext: String,
    };

    protected readonly getJobUrlValue!: string;
    protected readonly analyticsContextValue: string | undefined;
}